"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSectionContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("assets/styles/config");
exports.StyledSectionContainer = styled_components_1.default.div `
  background: ${config_1.colors.white};
  border: 1px solid ${config_1.colors.huron};
  border-radius: 8px;
  box-shadow: 0 2px 4px rgb(22 21 29 / 5%);
  margin-bottom: ${(props) => (props.margin ? props.margin : '0')};
  width: ${(props) => (props.width ? props.width : '48.25%')};
`;
